<!-- Client/ContactView.vue -->

<template>
    <section class="contact" v-if="contact.id">
        <Breadcrumb
            v-if="this.fromRelatedProject"
            :to="{name: 'projects.show', params: { projectId: this.fromRelatedProject.id }}"
            :title="this.fromRelatedProject.title"
        />
      <Breadcrumb
          v-if="this.fromCompany"
          :to="{name: 'companies.show', params: { companyId: this.fromCompany.id }}"
          :title="this.fromCompany.title"
      />
      <div class="flex flex-col lg:flex-row lg:justify-between lg:mb-4 space-y-2 lg:space-y-0">
        <div class="flex-grow">
          <h2 class="text-2xl text-cal-009588">{{ contact.first_name }} {{ contact.last_name }}</h2>
        </div>
        <div class="flex-shrink print:hidden">
          <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" @click="addNote">
            <svg xmlns="http://www.w3.org/2000/svg" width="12.326" height="12.326" viewBox="0 0 12.326 12.326">
              <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z" transform="translate(0 -2.25)" fill="#888"/>
            </svg>
            <span class="text-xs">{{ contact.note ? "Edit Note" : "Add Note" }}</span>
          </button>
          <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" v-if="$root.$data.auth.user.allowShare" @click="share">
            <svg xmlns="http://www.w3.org/2000/svg" width="15.387" height="13.677" viewBox="0 0 15.387 13.677">
              <path id="Icon_awesome-share-square" data-name="Icon awesome-share-square" d="M15.186,4.74,11.339,8.373a.642.642,0,0,1-1.081-.466V5.984c-3.862.026-5.491.938-4.4,4.577a.428.428,0,0,1-.668.463,5.142,5.142,0,0,1-1.983-3.83c0-3.845,3.141-4.608,7.052-4.63V.641A.642.642,0,0,1,11.339.175l3.847,3.633A.641.641,0,0,1,15.186,4.74Zm-4.928,5.387v1.84H1.71V3.419H3.07a.32.32,0,0,0,.231-.1A5.208,5.208,0,0,1,4.664,2.314a.32.32,0,0,0-.148-.6H1.282A1.282,1.282,0,0,0,0,2.992v9.4a1.282,1.282,0,0,0,1.282,1.282h9.4a1.282,1.282,0,0,0,1.282-1.282V10.023a.32.32,0,0,0-.428-.3,1.919,1.919,0,0,1-.913.09A.321.321,0,0,0,10.258,10.128Z" fill="#888"/>
            </svg>
            <span class="text-xs">Email contact</span>
          </button>
          <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" v-if="contact.user && contact.user.id" @click="remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="15.431" height="15.431" viewBox="0 0 17.431 17.431">
              <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z" transform="translate(10.306 -1.591) rotate(45)" fill="#888"/>
            </svg>
            <span class="text-xs">Remove</span>
          </button>
          <button class="text-sm text-bold py-1 px-2 uppercase bg-cal-81B920 text-white inline-flex items-center space-x-2" v-else @click="add">
            <svg xmlns="http://www.w3.org/2000/svg" width="12.326" height="12.326" viewBox="0 0 12.326 12.326">
              <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z" transform="translate(0 -2.25)" fill="#fff"/>
            </svg>
            <span class="text-xs">Add To My Contacts</span>
          </button>
        </div>
      </div>
        <div class="flex items-center justify-center border-t border-cal-E8E8E8 py-2.5" v-if="contact.user">
            <div class="flex-grow"></div>
            <div class="flex-shrink">
                <status-block
                    :current-status="contact.user.tag_id"
                    :options="tags"
                    v-on:selected-status="onSelectStatus">Folder</status-block>
            </div>
        </div>
      <div class="mb-4"></div>
      <div class="bg-gray-100 text-cal-4A4A4A text-sm p-4 mb-4" v-if="contact.user && contact.user.note">
        <div class="uppercase font-bold">NOTES</div>
        <div class="my-2">
          <div class="note-block-title">Note {{ utcToLocal(contact.user.created_at) }}</div>
          <div class="note-block-body">{{ contact.user.note }}</div>
        </div>
      </div>
      <div class="bg-white px-6 py-6">
        <div class="grid grid-cols-2 gap-6">
          <div>
            <h3 class="uppercase font-bold text-sm text-cal-204285">Company details</h3>
            <div class="divide-y divide-cal-EBEBEB">
              <detail-item label="Title">{{ contact.title }}</detail-item>
              <detail-item label="Company">{{ contact.company_name }}</detail-item>
              <detail-item label="Website">
                <a :href="contact.company_url" target="_blank" v-if="contact.company_url">
                  {{ contact.company_url }}
                </a>
                <span v-else>-</span>
              </detail-item>
              <detail-item label="Company type">
                <span v-if="contact.company_type && contact.company_type.name">{{ contact.company_type.name }}</span>
                <span v-else>-</span>
              </detail-item>
            </div>
          </div>
          <div>
            <h3 class="uppercase font-bold text-sm text-cal-204285">Contact</h3>
            <div class="grid grid-cols-2 gap-2">
              <div class="divide-y divide-cal-EBEBEB">
                <detail-item label="Email">
                  <a :href="'mailto:'+contact.email" v-if="contact.email">
                    {{ contact.email }}
                  </a>
                  <span v-else>-</span>
                </detail-item>
                <detail-item label="Phone number">
                  <a :href="'tel:'+phone(contact.phone)">
                    <vue-cond v-model="contact.phone"></vue-cond>
                  </a>
                </detail-item>
                <detail-item label="Phone number 2">
                  <a :href="'tel:'+phone(contact.phone2)">
                    <vue-cond v-model="contact.phone2"></vue-cond>
                  </a>
                </detail-item>
                <detail-item label="Phone number 3">
                  <a :href="'tel:'+phone(contact.phone3)">
                    <vue-cond v-model="contact.phone3"></vue-cond>
                  </a>
                </detail-item>
              </div>
              <div class="divide-y divide-cal-EBEBEB">
                <detail-item label="Fax number">
                  <a :href="'tel:'+phone(contact.fax)">
                    <vue-cond v-model="contact.fax"></vue-cond>
                  </a>
                </detail-item>
                <detail-item label="Location number">
                  <a :href="'tel:'+phone(contact.location_number)">
                    <vue-cond v-model="contact.location_number"></vue-cond>
                  </a>
                </detail-item>
                <detail-item label="Location fax">
                  <vue-cond v-model="contact.location_fax"></vue-cond>

                </detail-item>
                <detail-item label="Address">{{ address }}</detail-item>
              </div>
            </div>
          </div>
        </div>
      </div>
        <vue-modal
            v-if="showModal"
            @close="showModal = false">
            <div slot="header">
                <h3 v-if="!note">Add Note</h3>
                <h3 v-else>Edit Note</h3>
            </div>
            <div slot="body">
                <form-label is-for="contact_note">Note</form-label>
                <textarea id="contact_note" v-model="note" class="block mt-2 w-full sm:text-sm border border-gray-300 p-2"></textarea>
            </div>
            <div slot="footer">
                <vue-button
                    @click="saveNote()"
                    type="green large">Save</vue-button>
            </div>
        </vue-modal>
    </section>
</template>

<script>

import VueTable from '../Shared/VueTable.vue';
import ColumnView from '../Shared/ColumnView.vue';
import VueButton from '../Shared/VueButton.vue';
import VueModal from '../Shared/VueModal.vue';
import VueCond from '../Shared/VueCond.vue';
import StatusBlock from '../Shared/StatusBlock.vue';
import NoteBlock from '../Shared/NoteBlock.vue';
import Format from '../../mixins/Format';
import WebServices from '../../services/WebServices';
import FormLabel from "../Form/FormLabel";
import Breadcrumb from "../Shared/Breadcrumb.vue";
import DetailItem from "../Shared/DetailItem.vue";

export default {

    mixins: [Format],
    components: {
      DetailItem,
      FormLabel, VueTable, VueButton, VueModal, ColumnView, StatusBlock, NoteBlock, VueCond, Breadcrumb },

  data() {
    return {
      contactServices: WebServices("Contacts"),
      contact: {
        status: 0
      },
      showModal: false,
      tags: this.$root.$data.auth.user.contactTags,
      fromRelatedProject: null,
      fromCompany: null,
    }
  },

    created () {

        this.get();
    },

    computed: {
        note: {
            // getter
            get: function () {
                return this.contact.user.note ? this.contact.user.note : null;
            },
            // setter
            set: function (newValue) {

                if (this.contact.user) { this.contact.user = {}; }
                this.contact.user.note = newValue;
            }
        },

        address() {
            var str = "";
            if (this.contact.address1) { str += this.contact.address1; }
            str += "\n";
            if (this.contact.address2) { str += this.contact.address2; }
            str += "\n";
            if (this.contact.city) { str += this.contact.city + ", "; }
            if (this.contact.state) { str += this.contact.state + " "; }
            if (this.contact.zip) { str += this.contact.zip; }
            return str;
        },
    },

    methods: {

        get () {
            this.contactServices
                .getOne(this.$route.params.contactId)
                .then((response) => {
                    this.contact = response.data.data

                }, (response) => {
                    this.$router.push({ name: 'contacts' });
                });
        },

        add () {

            this.contactServices
                .store({contact_id: this.contact.id}, "Save")
                .then(
                    (response) => {
                      this.contact = response.data.data;
                    }
                );
        },

        remove () {

            this.contactServices
                .remove(this.contact.id)
                .then(function(response) {
                    this.get();
                }.bind(this));
        },

        addNote () {
            this.showModal = true
        },

        saveNote() {
            this.contactServices
                .store({
                    contact_id: this.contact.id,
                    note: this.contact.user.note
                }, "AddNote")
                .then(function(response) {
                    this.showModal = false
                    this.get();
                }.bind(this));
        },

        share () {

            var subject = this.contact.first_name + " " + this.contact.last_name + " - Construct-A-Lead";
            var body = "";

            body += "First Name: "+ this.contact.first_name;
            body += "\nLast Name: "+ this.contact.last_name;
            body += "\nCompany: "+ (this.contact.company || "–");
            if (this.contact.company_type) {
                body += "\nCompany Type: "+ this.contact.company_type.name;
            }
            body += "\nEmail: "+ (this.contact.email || "–");
            body += "\nWebsite: "+ (this.contact.url || "–");
            body += "\nPhone Number: "+ (this.contact.phone || "–");
            body += "\nPhone Number 2: "+ (this.contact.phone2 || "–");
            body += "\nPhone Number 3: "+ (this.contact.phone3 || "–");
            body += "\nFax Number: "+ (this.contact.fax || "–");

            var a = document.createElement('a');

            a.href = 'mailto: ?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
            a.setAttribute('style', 'display:none');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        onSelectStatus (status) {

            if (this.contact.user) {
                this.contact.user.tag_id = status.id;
            }

            this.contactServices
                .store({
                    contact_id: this.contact.id,
                    tag_id: status.id
                }, "AddTag")
                .then(function(response) {
                    this.get();
                }.bind(this));
        }
    },

    beforeRouteEnter (to, from, next) {
        if (to.params.relatedProject) {
            next(vm => {
                vm.fromRelatedProject = to.params.relatedProject
            });
        }
      if (to.params.company) {
        next(vm => {
          vm.fromCompany = to.params.company
        });
      }
        else { next(); }
    },

    watch: {
        '$root.$data.auth.user': {
            handler: function (val, oldVal) {
                this.tags = this.$root.$data.auth.user.contactTags;
            },
            deep: true
        }
    },
}

</script>
